import { BaseModel } from '../../../models/base-model'

import { TaskDifficulty } from './task-difficulty'

import { Resource, UserTask } from './..'
import { TreeUtils, ObjectHelper } from '../../../helpers'
import { ICloneable } from '../../../core/models'

export class Task extends BaseModel implements ICloneable<Task> {
  // Time in minutes that any given value should be rounded to
  private static roundingIntervals: number[] = [1, 5, 10, 15, 20, 30, 45, 60, 75, 90, 120, 150, 180, 210, 240, 300]

  public title: string
  public description: string
  public duration: number
  public resourceId: string
  public resource: Resource
  public tasks: Task[]
  public optional: boolean
  public difficulty: TaskDifficulty
  public taskType: string
  public userTask: UserTask

  private _treeUtils: TreeUtils
  private _objectHelper: ObjectHelper
  private _durationApproximationResult: number

  /**
   * @param tasks Array of tasks for which valid, present difficulties shall be determined
   * @return Returns all valid task difficulties which are present in an array of tasks
   */
  public static getPresentTaskDifficulties(tasks: Task[]): Set<TaskDifficulty> {
    return new Set<TaskDifficulty>(tasks.reduce((validDifficulties: TaskDifficulty[], task: Task) => {
      if (typeof TaskDifficulty[task.difficulty] !== 'undefined') {
        validDifficulties.push(task.difficulty)
      }
      return validDifficulties
    }, []))
  }

  constructor() {
    super()
    this.tasks = []
    this._objectHelper = new ObjectHelper()
    this._treeUtils = new TreeUtils()
  }

  public durationApproximation(): number {
    return this._durationApproximationResult ||
      (this._durationApproximationResult = Task.roundingIntervals.find((intervalElement: number) => {
        return this.duration <= intervalElement
      }) || Task.roundingIntervals[Task.roundingIntervals.length - 1])
  }

  public getAllChildTasks(): Task[] {
    return this._treeUtils.reduce<Task>(this, 'tasks', (result, task) => {
      result.push(task)
      return result
    }, [])
  }

  public hasChildTask(taskToFind: Task): boolean {
    return this._treeUtils.some(this, 'tasks', (task) => task === taskToFind)
  }

  public getDifficultyLabel() {
    return ((this.difficulty in TaskDifficulty) ?
      TaskDifficulty[this.difficulty] :
      TaskDifficulty[TaskDifficulty.Unknown]).toLowerCase()
  }

  public clone(options?: { exclude?: string[], include?: string[], shallow?: string[] }) {
    return this._objectHelper.clone<Task>(Task, this, {
      include: ['title', 'description', 'nodeType', 'pathNodes', 'tasks'],
      shallow: ['tasks']
    }, options)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/task/task.ts